import {fetchPreferences} from "../../common/Metadata";
import {createListViewColumns, initKendoGrid} from "../list/ListViewColumns";
import {ajaxJSON, ajaxJSONWithoutWait, ajaxJSONWithTask, namaCompare, nextId, registerOnWindowResize} from "../../common/NamaCommon";
import * as NamaURLS from '../../constants/NamaURLS'
import SearcherWindowTemplate from "../../compiled-templates/SearcherWindowTemplate";
import * as PreferencesRequest from "../../constants/PreferencesRequest";
import * as OwnerType from "../../constants/OwnerType";
import * as ts from "../../common/Translator";
import {translate, translateId} from "../../common/Translator";
import {addArabicEnglishToData, CriteriaEditorWidget} from "../list/CriteriaEditorWidget";
import {dropDownFiltering} from "../../widgets/DropDownListWidget";
import {toNewSearchUI} from "./CustomItemSearcherWindow";
import {shouldApplyNewSearchUI} from "../../grid/NamaGridWidget";
import {userCanSearch} from "../../login/Security";
import {appendRow} from "../../grid/GridEventsController";
import {setItemCollapseAttr} from "../edit/EditScreenGroup";
import {collapseItemIfNeeded} from "../../routing/EditPresenter";

export function bindClickOnSelectAll(grid) {
    grid.bind("click", "th.nama-selectAll-header",
        (e) => {
            let target = $(e.target);
            if (!target.parent().is("th") && !target.parent().parent().is("th"))
                return;
            let selectAll = target.parent().find(".k-checkbox").prop("checked");
            updateCheckBoxes(selectAll, grid);
        }
    );
}

export function fetchSelectorPopupPreferences(entityType, callback) {
    /**
     *
     * @type {namaTypes.FetchPreferencesRequest}
     */
    let req = {};
    req.owner = {ownerType: OwnerType.Entity, ownerId: entityType};
    req.properties = [PreferencesRequest.META_DATA, PreferencesRequest.LIST_LAYOUT, PreferencesRequest.EDIT_LAYOUT, PreferencesRequest.SEARCHER_LAYOUT];
    fetchPreferences(req, (preferences) => {
        if (callback)
            callback(preferences);
    });
}

/**
 * @implements NamaGridOwner
 * @property {kendo.data.DataSource} dataSource
 */
export class ReferenceSelectorPopup {
    /**
     *
     * @param {ReferenceWidget} owner
     * @param {string} entityType
     */
    constructor({
                    owner,
                    entityType,
                    refSelectedCallBack,
                    contextInfo,
                    inChangeDimsDialog,
                    defaultCriteria,
                    preferences,
                    extraCriteria,
                    srcColumnId,
                    fromQuestionList
                }) {
        this.owner = owner;
        this.entityType = entityType;
        this.refSelectedCallBack = refSelectedCallBack;
        this.contextInfo = contextInfo;
        this.inChangeDimsDialog = inChangeDimsDialog;
        this.defaultCriteria = defaultCriteria;
        this.allowRequests = true;
        this.preferences = preferences;
        this.extraCriteria = extraCriteria;
        this.srcColumnId = srcColumnId;
        this.fromQuestionList = fromQuestionList;
    }

    async selectionCallBack(ref) {
        return await this.refSelectedCallBack(ref);
    }

    loadPreferences() {
        let that = this;
        if (that.preferences) {
            that.showPopup(that.notInWindow);
            return;
        }
        fetchSelectorPopupPreferences(that.entityType, (preferences) => {
            /**
             * @type {namaTypes.UIPreferences}
             */
            that.preferences = preferences;
            that.showPopup(that.notInWindow);
        });
    }

    showPopup(notInWindow) {
        let that = this;
        if (!userCanSearch(that.entityType))
            return;
        that.notInWindow = notInWindow;
        if (!that.preferences) {
            that.loadPreferences();
            return;
        }
        if (!that.rootElement)
            that.initUI();
        else
            that.resetElements();
        if (notInWindow)
            return;
        that.kendowWindow.open().center();
        that._resizeColumns();
    }

    resetElements() {
        let that = this;
        that.rootElement.find("#search-text").val("");
        if (that.rootElement.find("#searchIn").data("kendoDropDownList"))
            that.rootElement.find("#searchIn").data("kendoDropDownList").value("All");
        if (that.rootElement.find("#sortOn").data("kendoDropDownList"))
            that.rootElement.find("#sortOn").data("kendoDropDownList").value("code");
        if (that.rootElement.find("#ascOrDesc").data("kendoDropDownList"))
            that.rootElement.find("#ascOrDesc").data("kendoDropDownList").value("asc");
    }

    attachWindowEvents() {
        let that = this;
        let grid = that.rootElement.find("#grid").data("kendoGrid");
        let onClick = (e) => {
            let target = $(e.target);
            let currentRow = target.closest("tr");
            if (target.hasClass("k-checkbox")) {
                if (!currentRow.hasClass("selectedByCheckBox"))
                    currentRow.addClass("selectedByCheckBox");
                else
                    currentRow.removeClass("selectedByCheckBox");
                that.updateRowsSelectionStatus();
            } else {
                e.preventDefault();
            }
            if (!currentRow.length)
                return;
            if (that.rootElement.find("#grid").find("tr.selectedByCheckBox").length || target.hasClass("k-checkbox-label") || target.hasClass("row-number"))
                return;
            let currentRowIndex = currentRow[0].rowIndex;
            let data = grid.dataSource.data();
            let dataItem = data[currentRowIndex];
            if (dataItem && dataItem.values) {
                ajaxJSON(NamaURLS.FIND_REF_BY_ID, {
                    entityType: dataItem.values.entityType,
                    id: dataItem.values.id
                }, (ref) => {
                    that.refSelectedCallBack(ref);
                });
                if (!that.notInWindow)
                    that.kendowWindow.destroy();
            }
        };
        that.rootElement.find("#grid").bind("click", onClick);
        that.rootElement.find("#grid").bind("focusout", ".row-number",
            that.selectLineIfNeeded()
        );
        that.rootElement.find("#grid").bind("keypress", ".row-number",
            that.selectLineIfNeeded(true)
        );
        bindClickOnSelectAll(that.rootElement.find("#grid"));
    }

    selectLineIfNeeded(fromKeyPress) {
        let that = this;
        return (e) => {
            let key = e.keyCode;
            if (!fromKeyPress || (fromKeyPress && key == kendo.keys.ENTER)) {
                let target = $(e.target);
                let currentRow = target.closest("tr");
                let rowCount = target.val();
                if (rowCount > 0) {
                    currentRow.addClass("selectedByCheckBox");
                    currentRow.find(".k-checkbox").prop('checked', true);
                    that.updateRowsSelectionStatus();
                }
            }
        };
    }

    layoutPrefix() {
        return "search";
    }

    place_() {
        return null;
    }

    async insertSelectedRowsToOwnerGrid(gridElement, insertAtEnd, itemMustBeOrdered) {
        let that = this;
        if (!that.owner._kendoGrid)
            return;
        let rows = gridElement.find(".k-grid-content").find("table").find("tr.selectedByCheckBox");
        if (!rows.length)
            return;
        if (itemMustBeOrdered)
            rows.sort((r1, r2) => namaCompare($(r1).find(".row-number")[0].value, $(r2).find(".row-number")[0].value));
        let ownerGrid = that.owner._kendoGrid();
        let insertFromIndex = ownerGrid.current() ? ownerGrid.current().parent().index() : ownerGrid.dataSource.data().length - 1;
        if (insertAtEnd)
            insertFromIndex = ownerGrid.dataSource.data().length - 1;
        let selectedEntityType = null;
        let selectedIds_ = [];
        let refIdsWithCount = new Map();
        for (let r of rows) {
            let dataItem = gridElement.data("kendoGrid").dataItem(r);
            if (!selectedEntityType)
                selectedEntityType = dataItem.values.entityType;
            if (!selectedIds_.contains(dataItem.values.id))
                selectedIds_.push(dataItem.values.id);
            let count = $(r).find(".row-number")[0].value;
            if (!count || itemMustBeOrdered)
                count = 1;
            refIdsWithCount.set(dataItem.values.id, count);
        }
        ajaxJSONWithTask(NamaURLS.FIND_REFS_BY_IDS,
            {
                entityType: selectedEntityType,
                ids: JSON.stringify(selectedIds_)
            }, (refs) => {
                that.addRefsToParentGrid(refs, insertFromIndex, refIdsWithCount);
            });
    }

    async addRefsToParentGrid(refs, insertionIndex, refIdsWithCount) {
        let that = this;
        that.owner.addingMultiRefs = true;
        try {
            for (let i = 0; i < refs.length; i++) {
                let count = refIdsWithCount.get(refs[i].id);
                for (let j = 0; j < count; j++) {
                    appendRow(that.owner._kendoGrid(), false, that.owner, false, false, {},
                        insertionIndex, insertionIndex, (item) => that.owner.refSelectionCallBack(that.srcColumnId, refs[i], item, i == refs.length - 1), i == refs.length - 1, that.fromQuestionList);
                    insertionIndex++;
                }
            }
        } catch (e) {
            console.log(e);
            that.owner.addingMultiRefs = false;
        }

    }

    _resizeColumns() {
        let that = this;
        if (that.readRequestInProgress) {
            setTimeout(() => that._resizeColumns(), 200);
            return;
        }
        that.allowRequests = false;
        let kendoGrid = that.rootElement.find("#grid").data("kendoGrid");
        if (!kendoGrid)
            return;
        let headerCells = that.rootElement.find(".k-grid-header").find("th.k-header");
        let totalColumnWidthes = 0;
        let widthes = [];
        let newwidthes = [];
        for (let i = 0; i < headerCells.length; i++) {
            let columnWidth = Math.max($(headerCells[i]).width(), 32.5);
            totalColumnWidthes += columnWidth;
            widthes.push(columnWidth);
        }
        let totalGridWidth = that.rootElement.find("#grid").width() - 20;
        if (totalColumnWidthes < totalGridWidth) {
            var newOptions = $.extend({}, kendoGrid.getOptions());
            for (let i = 0; i < widthes.length; i++) {
                let colWidth = widthes[i] * totalGridWidth / totalColumnWidthes;
                colWidth = Math.max(colWidth, 30)
                newOptions.columns[i].width = colWidth;
                newwidthes.push(newOptions.columns[i].width)
            }
            newOptions.height = that._calcGridHeight();
            kendoGrid.setOptions(newOptions);
        } else {
            let gridHeight = that._calcGridHeight();
            that.rootElement.find("#grid").height(gridHeight);
            if (!that.rootElement.find("#grid").css('min-height') ||
                that.rootElement.find("#grid").css('min-height') === "0px")
                that.rootElement.find("#grid").css('min-height', gridHeight / 2 + 'px')
            kendoGrid.resize();
        }
        that.allowRequests = true;
    }

    initUI() {
        let that = this;
        that.elementId = nextId();
        /**
         *
         * @type {NamaJquery}
         */
        that.rootElement = $(SearcherWindowTemplate({elementId: that.elementId, translateId: ts.translateId}));
        that.criteriaWidget = new CriteriaEditorWidget({
            rootElement: that.rootElement,
            presenter: undefined,
            oldCriteria: undefined,
            metadata: that.preferences.metaData,
            entityType: that.preferences.metaData.owner.ownerId,
            criteriaFields: that.preferences.listLayout.criteriaFields,
            owner: that
        });
        that.criteriaWidget.render();
        that.groupHeader = that.rootElement.find(".toggle-info");
        setItemCollapseAttr({
            entityType: that.entityType,
            viewName_: () => "searcherWindow"
        }, that.groupHeader, "");
        that.groupHeader.on("namaCollapse", () => {
            if (!that.rootElement.find("#grid") || !that.rootElement.find("#grid").data("kendoGrid"))
                return;
            that.rootElement.find("#grid").height(that._calcGridHeight())
            that.rootElement.find("#grid").data("kendoGrid").resize();
        });
        if (!that.currentWindowIsInGrid()) {
            that.rootElement.find("#insertRowAtEnd").remove();
            that.rootElement.find("#insertRowsAtEndByOrder").remove();
            that.rootElement.find("#insertRow").remove();
            that.rootElement.find("#cancel").remove();
            that.rootElement.find("#ok").remove();
        }
        if (!that.rootElement.find(".searcherWindowBtns").children().length)
            that.rootElement.find(".searcherWindowBtns").remove();
        that.rootElement.find("#searchButton").on("click", (e) => {
            e.preventDefault();
            that.refresh();
        });
        that.rootElement.find("#insertRowAtEnd").on("click", (e) => {
            e.preventDefault();
            that.insertSelectedRowsToOwnerGrid(that.rootElement.find("#grid"), true, false);
            that.restoreSearchWindowView();
        });
        that.rootElement.find("#insertRowsAtEndByOrder").on("click", (e) => {
            e.preventDefault();
            that.insertSelectedRowsToOwnerGrid(that.rootElement.find("#grid"), true, true);
            that.restoreSearchWindowView();
        });
        that.rootElement.find("#insertRow").on("click", (e) => {
            e.preventDefault();
            that.insertSelectedRowsToOwnerGrid(that.rootElement.find("#grid"), false, false);
            that.restoreSearchWindowView();
        });
        that.rootElement.find("#ok").on("click", (e) => {
            e.preventDefault();
            that.insertSelectedRowsToOwnerGrid(that.rootElement.find("#grid"), false, false);
            that.kendowWindow.destroy();
        });
        that.rootElement.find("#cancel").on("click", (e) => {
            e.preventDefault();
            that.kendowWindow.destroy();
        });
        if (shouldApplyNewSearchUI(that.entityType) && !that.notInWindow) {
            let toNewSearchUIBtn = $(`<button id = "toNewSearchUI"></button>`);
            toNewSearchUIBtn.attr("title", translateId("toNewSearchUI"));
            that.rootElement.find(".searcherWindowBtns").append(toNewSearchUIBtn);
            toNewSearchUIBtn.kendoButton({
                icon: "upload",
                click: (e) => {
                    toNewSearchUI(that);
                }
            });
        }
        that.model = kendo.data.Model.define({});
        Object.defineProperty(that.model.prototype, "$translatedFieldId", {
            enumerable: false, configurable: true, get: function () {
                return ts.translateId(this.id);
            }, set: function (value) {
            }
        });
        let sortOnField = that.rootElement.find("#sortOn");
        let ascOrDesc = that.rootElement.find("#ascDescGroup");
        sortOnField.kendoMultiSelect({
            dataSource: new kendo.data.DataSource({
                data: that.preferences.listLayout.sortColumns,
                schema: {
                    model: that.model
                }
            }),
            dataTextField: "$translatedFieldId",
            dataValueField: "id",
            filter: "contains",
            placeholder: translateId("sortOn"),
            change: e => {
                that.refresh();
            }
        });
        sortOnField.parent().find("input.k-input-inner").attr("placeholder", translateId("sortOn"));
        ascOrDesc.kendoButtonGroup({
            items: [
                {text: translate("asc", that.entityType)},
                {text: translate("desc", that.entityType)},
            ],
            select: function (e) {
                that.refresh();
            }
        });
        let ascOrDescData = ascOrDesc.data("kendoButtonGroup");
        ascOrDescData.select(0);
        let conditionsGroup = that.rootElement.find("#conditionsGroup");
        conditionsGroup.kendoButtonGroup({
            items: [
                {text: ts.translateId("AllConditions")},
                {text: ts.translateId("AnyCondition")}

            ],
            select: function (e) {
                that.refresh();
            }
        });
        let condGroupData = conditionsGroup.data("kendoButtonGroup");
        condGroupData.select(0);
        let searchInField = that.rootElement.find("#searchIn");
        let searchInData = [{id: "All"}, {id: "code"}, {id: "name1"}, {id: "name2"}];
        addArabicEnglishToData(searchInData);
        searchInField.kendoDropDownList({
            filter: "contains",
            dataSource: new kendo.data.DataSource({
                data: searchInData,
                schema: {
                    model: that.model
                }
            }),
            dataTextField: "$translatedFieldId",
            dataValueField: "id",
            value: "All",
            change: e => {
                that.refresh();
            },
            filtering: function (ev) {
                dropDownFiltering(ev, this.dataSource);
            },
        });
        that.rootElement.find("#search-text").on("keypress", (e) => {
            if (e.keyCode === kendo.keys.ENTER)
                that.refresh();
        });

        let kWindowDim = _calcWindowDimensions();
        if (!that.notInWindow) {
            /**
             * @type {kendo.ui.Window}
             */
            that.kendowWindow = that.rootElement.kendoWindow({
                width: kWindowDim.width,
                height: kWindowDim.height,
                resizable: true,
                title: ts.translateId("select") + " " + ts.translateId(that.entityType),
                visible: false,
                actions: [
                    "Maximize",
                    "Close"
                ],
                open: function () {
                    setTimeout(() => {
                        that._onBrowserWindowResize();
                    })
                }, resize: function () {
                    that._onKendoWindowResize();
                }, refresh: function (e) {
                    this.center();
                },
                close: function (e) {
                    that.kendowWindow.destroy();
                }

            }).data("kendoWindow");
            registerOnWindowResize(window[0], (e) => {
                that._onBrowserWindowResize();
            });
        }
        that.model = {};
        let hasParentId = that.currentWindowIsInGrid();
        let windowWidth = kWindowDim.width.replace("%", "");
        let w = (windowWidth / 100) * $(window).width();
        that.displayColumns = createListViewColumns(that, that.preferences.searcherLayout, that.model, w, hasParentId, hasParentId, that.preferences.metaData);
        let selectable = "single, row";
        if (hasParentId)
            selectable = true;
        initKendoGrid(that, selectable);
        that.attachWindowEvents();
        if (that.afterInitUICallback)
            that.afterInitUICallback();
        collapseItemIfNeeded(that.groupHeader);
    }

    criteriaWidget_() {
        return this.criteriaWidget;
    }

    autoFitLocalStorageKey() {
        return this.entityType + "selectorAutoFitColsApplied";
    }

    ascOrDesc() {
        let that = this;
        let data = that.rootElement.find("#ascDescGroup").data("kendoButtonGroup");
        return data.current().index() == 0;
    }

    orderBy() {
        let that = this;
        let sortByFields = that.rootElement.find("#sortOn").data("kendoMultiSelect").value();
        let sortBy = "";
        for (let field of sortByFields) {
            if (!sortBy.contains(field))
                sortBy += field + ",";
        }
        sortBy = sortBy.substring(0, sortBy.length - 1);
        return sortBy;
    }

    setHeightOfListViewGrid() {
        this._resizeColumns();
    }

    currentWindowIsInGrid() {
        let that = this;
        if (that.contextInfo && (that.contextInfo.sourcFieldParentId || that.contextInfo.inQuestionList))
            return true;
        return false;
    }

    restoreSearchWindowView() {
        let that = this;
        let restoreView = () => {
            that.updateAllRowNumbers("1");
            updateCheckBoxes(false, that.rootElement.find("#grid"));
        };
        setTimeout(restoreView, 25);
    }

    updateAllRowNumbers(value) {
        let that = this;
        let rowNumberFields = that.rootElement.find("#grid").find(".row-number");
        for (let field of rowNumberFields) {
            $(field).val(value);
        }
    }

    calcPageSize() {
        return 25;
    }

    calcCurrentPage() {
        return 1;
    }

    _calcWindowDimensions() {
        let browserWidth = $(window).width();
        let browserHeight = $(window).height();
        let width = 0, height = 0;
        if (browserWidth > 768) {
            width = browserWidth * 85 / 100;
            height = browserHeight * 85 / 100;
        } else {
            width = browserWidth - 20;
            height = browserHeight - 20;
        }
        return {width: width, height: height};
    }

    _onDataBound() {
        let that = this;
        var view = that.dataSource.view();
        for (var i = 0; i < view.length; i++) {
            if (that.checkedIds[view[i].id]) {
                that.tbody.find("tr[data-uid='" + view[i].uid + "']")
                    .addClass("k-selected")
                    .find(".checkbox")
                    .attr("checked", "checked");
            }
        }
    }

    _selectRow() {
        let that = this;
        let checked = that.checked,
            row = $(that).closest("tr"),
            grid = $("#grid").data("kendoGrid"),
            dataItem = grid.dataItem(row);

        that.checkedIds[dataItem.id] = checked;
        if (checked) {
            //-select the row
            row.addClass("k-selected");
        } else {
            //-remove selection
            row.removeClass("k-selected");
        }
    }

    refresh() {
        let that = this;
        let grid = that.rootElement.find("#grid").data("kendoGrid");
        grid.dataSource.read();
    }

    readFromServer(options) {
        let that = this;
        if (!that.allowRequests) {
            options.success(that.lastFetchedResult || {page: [], totalRecordsCount: 0});
            return;
        }
        if (that.lastFetchedResultForPageSizeChange) {
            let x = that.lastFetchedResultForPageSizeChange;
            that.lastFetchedResultForPageSizeChange = undefined;
            options.success(x);
            return;
        }
        let extraCriteria = that.owner.extraCriteria;
        if (that.owner.fetchExtraCriteria) {
            let extraCriteria_ = that.owner.fetchExtraCriteria();
            if (extraCriteria_) {
                extraCriteria = extraCriteria_;
                that.contextInfo = null;
            }
        }
        that.readRequestInProgress = true;
        /**
         * @type {kendo.data.DataSource}
         */
        let dataSource = that.rootElement.find("#grid").data("kendoGrid").dataSource;
        /**
         *
         * @type {namaTypes.ListRequest}
         */
        let request = {
            owner: {ownerType: OwnerType.Entity, ownerId: that.entityType},
            forSearch: true,
            columns: that.displayColumnIds,
            criteria: that.criteriaWidget.calcCriteria().build(),
            entityType: that.entityType,
            startPage: options.data.page - 1,
            pageSize: options.data.pageSize,
            valueToSearch: that.rootElement.find("#search-text").val(),
            columnsToSearchIn: that.columnsToSearchIn(),
            extraCriteria: extraCriteria,
            ascending: that.ascOrDesc(),
            orderBy: that.orderBy(),
        };
        if (that.defaultCriteria)
            request.criteria = that.criteriaWidget.calcCriteria().build().join(that.defaultCriteria);
        if (that.extraCriteria)
            request.extraCriteria = that.extraCriteria;
        ajaxJSONWithoutWait(NamaURLS.ListForSearchView, {
            request: JSON.stringify(request),
            contextInfo: JSON.stringify(that.contextInfo),
            inChangeDimsDialog: that.inChangeDimsDialog

        }, (result) => {
            let resultLength = result.pageSize;
            let fetchedResult = result;
            if (options.data.pageSize != resultLength) {
                options.data.pageSize = resultLength;
                that.lastFetchedResultForPageSizeChange = fetchedResult;
                dataSource.pageSize(resultLength);
            }
            that.lastFetchedResult = fetchedResult;
            options.success(fetchedResult);
            that.readRequestInProgress = false;
        })
    }

    columnsToSearchIn() {
        let that = this;
        let searchIn = that.rootElement.find("#searchIn");
        let value = searchIn.data("kendoDropDownList").value();
        if (!value)
            return ["code"];
        if (value === "All")
            return ["code", "name1", "name2"];
        return [value];
    }

    get displayColumnIds() {
        return this.preferences.searcherLayout.displayColumns.map((c) => c.id);
    }

    _onBrowserWindowResize() {
        let that = this;
        this._onKendoWindowResize();
        that.kendowWindow.center();
        setTimeout(() => that._onKendoWindowResize());
    }

    _onKendoWindowResize() {
        this._resizeColumns();
    }

    _calcGridHeight() {
        let rootElement = $("#window" + this.elementId);
        let height = rootElement.height();
        let criteriaAndSearchWidgetHeight = rootElement.find(`.nama-collapsable`).outerHeight(true);
        return height - rootElement.find(".searcherWindowBtns").outerHeight() - 20 - criteriaAndSearchWidgetHeight;
    }

    updateRowsSelectionStatus() {
        let that = this;
        let grid = that.rootElement.find("#grid");
        let rows = grid.find("tr.selectedByCheckBox");
        for (let currentRow of rows) {
            grid.find("tr[data-uid=" + $(currentRow).attr("data-uid") + "]").addClass("k-selected");
        }
    }
}

export function _calcWindowDimensions() {
    let browserWidth = $(window).width();
    let width = 0, height = 0;
    if (browserWidth > 768) {
        width = "85%";
        height = "85%";
    } else {
        width = "98%";
        height = "98%";
    }
    return {width: width, height: height};
}

export function updateCheckBoxes(selectAll, grid) {
    let checkBoxes = grid.find(".k-checkbox");
    for (let checkBox of checkBoxes) {
        $(checkBox).prop('checked', selectAll);
    }
    let rows = grid.find("tr");
    for (let currentRow of rows) {
        let row = $(currentRow);
        if (selectAll) {
            row.addClass("selectedByCheckBox");
            row.addClass("k-selected");
        } else {
            row.removeClass("selectedByCheckBox");
            row.removeClass("k-selected");
        }
    }
}